export const PATIENT_ORDERS_ACTION = 'PATIENT_ORDERS_ACTION';
export const PATIENT_INVENTORY_ACTION = 'PATIENT_INVENTORY_ACTION';
export const PATIENT_APPOINTMENT_ACTION = 'PATIENT_APPOINTMENT_ACTION';
export const PATIENT_INVITE_ACTION = 'PATIENT_INVITE_ACTION';

export const APPOINTMENT_PHOTO_ACTION = 'APPOINTMENT_PHOTO_ACTION';
export const APPOINTMENT_PROCEDURE_PHOTO_ACTION = 'APPOINTMENT_PHOTO_ACTION';
export const APPOINTMENT_INVITE_ACTION = 'APPOINTMENT_INVITE_ACTION';

export const DOCTOR_PAYER_ACTION = 'DOCTOR_PAYER_ACTION';

export const USER_WORK_SHIFT_ACTION = 'USER_WORK_SHIFT_ACTION';
